import axios from "axios";
import { handleHttpError } from "../Error";
import { getAuthState } from "../autStateHolder";
import i18next from "i18next";
import fetchAdapter from "../../Utilities/Axios/axiosFetchAdapter";

require("dotenv").config();

const {
  REACT_APP_API_URL: baseURL,
  REACT_APP_ALLOW_LANGUAGE_SELECTION,
  REACT_APP_ML_APP_API_URL: mlBaseURL,
  REACT_APP_ML_SUBSCRIPTION_KEY: mlSubscriptionKey,
  REACT_APP_APIM_SUBSCRIPTION_KEY: apiSubscriptionKey,
  REACT_APP_ENV_NAME: envName,
} = process.env || {};

const languageSelctionAllowed =
  parseInt(REACT_APP_ALLOW_LANGUAGE_SELECTION, 10) === 1 || false;

const instance = axios.create({
  baseURL,
  //adapter: fetchAdapter,
});

const mlInstance = axios.create({
  baseURL: mlBaseURL,
  //adapter: fetchAdapter,
});

mlInstance.interceptors.request.use(
  async (config) => {
    const authState = getAuthState();
    if (authState) {
      config.headers.Authorization = `Bearer ${authState.accessToken}`;
    }

    config.headers["subscription-key"] = mlSubscriptionKey;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.request.use(
  async (config) => {
    const authState = getAuthState();
    if (authState) {
      config.headers.Authorization = `Bearer ${authState.accessToken}`;
    }
    config.headers["accept-language"] = languageSelctionAllowed
      ? i18next.language
      : "en";
    config.headers["Content-Type"] = "multipart/form-data";
   
    config.headers["subscription-key"] = apiSubscriptionKey;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const { message, response } = err || {};
    const { status, data } = response || {};
    const { error } = data || {};
    console.log(`ERROR: ${message}`, response);
    handleHttpError(status, error);
    return Promise.reject(error || data || response);
  },
);

const httpPost = async (url, data) => {
  try {
    return instance.post(url, data);
  } catch (error) {
    throw error;
  }
};

const httpGet = async (url, params, getResponseHeaders = false) => {
  try {
    const response = await instance.get(url, {
      params,
      headers: {
        accept: "*/*",
      },
      responseType: "arraybuffer",
    });
    if (getResponseHeaders) {
      return { data: response.data, headers: response.headers };
    }
    const { data } = response || {};
    return data || response;
  } catch (error) {
    throw error;
  }
};

const httpGetF = async (url, params) => {
  try {
    const response = await instance.get(url, {
      params: params,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const { data } = response || {};
    return data || response;
  } catch (error) {
    throw error;
  }
};

const mlHttpPost = async (url, data) => {
  try {
    const response = await mlInstance.post(url, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { baseURL, mlBaseURL, httpGet, httpPost, httpGetF, mlHttpPost };
